import { PageIndicator } from './PageIndicator';

import './PageIndicator.less'

export default PageIndicator;

